export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const scrollToElementWithOffset = (targetId, headerId) => {
  let offsetPosition = 0;
  const element = document.getElementById(targetId);
  if (!element) return;

  const headerHeight = document.getElementById(headerId)?.clientHeight || 0;
  const bodyTop = document.body?.getBoundingClientRect()?.top || 0;
  const elementTop = element.getBoundingClientRect()?.top || 0;
  const elementPosition = elementTop - bodyTop;
  offsetPosition = elementPosition - headerHeight;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
};
